// Helper function to add doctor filter to API calls
export const getDoctorFilterParams = (user) => {
  // If user is a doctor (has doctorId), return filter params
  if (user && user.role === 'doctor' && user.doctorId) {
    return { doctorId: user.doctorId };
  }
  // Admin and receptionist see all data
  return {};
};

// Helper to check if user is doctor
export const isDoctor = (user) => {
  return user && user.role === 'doctor';
};

// Helper to check if user is admin
export const isAdmin = (user) => {
  return user && user.role === 'admin';
};

// Helper to get doctor ID from user
export const getDoctorId = (user) => {
  return user && user.doctorId ? user.doctorId : null;
};
